import {
  LIST_INFO_FINANCEIRAS_INIT,
  LIST_INFO_FINANCEIRAS_SUCCESS,
  CREATE_INFO_FINANCEIRAS_INIT,
  CREATE_INFO_FINANCEIRAS_SUCCESS,
  UPDATE_INFO_FINANCEIRAS_INIT,
  UPDATE_INFO_FINANCEIRAS_SUCCESS,
  DELETE_INFO_FINANCEIRAS_INIT,
  DELETE_INFO_FINANCEIRAS_SUCCESS,
  LIST_DRES_INIT,
  LIST_DRES_SUCCESS,
  INFO_FINANCEIRAS_ERROR_MSG,
  CLEAR_INFO_FINANCEIRAS
} from '../actionTypes';
import { IInfoFinanceiro } from 'src/integracoes/servicos/mongo-atlas/modelos/IInfoFinanceiras';
import { IDre } from 'src/integracoes/servicos/mongo-atlas/modelos/IDre';

const INIT_STATE = {
  infoFinanceirasList: [] as IInfoFinanceiro[],
  dresList: [] as IDre[],
  loading: false,
  error: false,
  success: false,
  deleted: false,
  updated: false,
  msg: null
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_INFO_FINANCEIRAS_INIT:
      return { ...state, loading: true };
    case LIST_INFO_FINANCEIRAS_SUCCESS: {
      const { infoFinanceiras } = action.payload;
      return { ...state, infoFinanceirasList: infoFinanceiras, loading: false, error: false };
    }
    case CREATE_INFO_FINANCEIRAS_INIT:
      return { ...state, loading: true, success: false };
    case CREATE_INFO_FINANCEIRAS_SUCCESS: {
      const { data, msg } = action.payload;
      return {
        ...state,
        infoFinanceirasList: [...state.infoFinanceirasList, data],
        loading: false,
        success: true,
        msg
      };
    }
    case UPDATE_INFO_FINANCEIRAS_INIT:
      return { ...state, loading: true, updated: false };
    case UPDATE_INFO_FINANCEIRAS_SUCCESS: {
      const { data, msg } = action.payload;
      return {
        ...state,
        infoFinanceirasList: state.infoFinanceirasList.map((item: IInfoFinanceiro) =>
          item._id === data._id ? data : item
        ),
        loading: false,
        updated: true,
        msg
      };
    }
    case DELETE_INFO_FINANCEIRAS_INIT:
      return { ...state, loading: true, deleted: false };
    case DELETE_INFO_FINANCEIRAS_SUCCESS: {
      const { id, msg } = action.payload;
      return {
        ...state,
        infoFinanceirasList: state.infoFinanceirasList.filter((item: IInfoFinanceiro) => item._id !== id),
        loading: false,
        deleted: true,
        msg
      };
    }
    case INFO_FINANCEIRAS_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, error: true, msg };
    }
    case LIST_DRES_INIT:
      return { ...state, loading: true };
    case LIST_DRES_SUCCESS: {
      const { dres } = action.payload;
      return { ...state, dresList: dres, loading: false, error: false };
    }
    case CLEAR_INFO_FINANCEIRAS:
      return { ...state, loading: false, error: false, success: false, deleted: false, updated: false, msg: null };
    default:
      return state;
  }
};
